var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"h-100"},[_c('b-card-title',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_c('vue-apex-charts',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }